import type { TValuesTimeseriesBlocks } from 'App/Map/types'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'

type TBlocksBody = {
  blockIds: number[]
  valuesRequested: Record<string, { preferredAggregationInterval: string }>
}

export const getBlocksBody = (options: {
  blockIds: string[]
  interval: string
  property: TProperty
  valueTypes: string[]
}): TBlocksBody => {
  const { blockIds, interval, property, valueTypes } = options

  return blockIds.reduce<TBlocksBody>(
    (blocksBody, blockIdStr) => {
      const blockId = Number(blockIdStr)
      const block = property?.blocks?.[blockId]

      if (!block?.valuesTimeseries) {
        return blocksBody
      }

      let includeBlock = false

      valueTypes.forEach((valueType) => {
        if (block.valuesTimeseries.includes(valueType as TValuesTimeseriesBlocks)) {
          includeBlock = true

          if (!blocksBody.valuesRequested[valueType]) {
            blocksBody.valuesRequested[valueType] = { preferredAggregationInterval: interval }
          }
        }
      })

      if (includeBlock && !blocksBody.blockIds.includes(blockId)) {
        blocksBody.blockIds.push(blockId)
      }

      return blocksBody
    },
    { blockIds: [], valuesRequested: {} },
  )
}
